import { Accordion, AccordionTab } from "primereact/accordion";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import { useCallback, useRef, useState } from "react";
import { useDrag, useDrop } from "react-dnd";
import { useTranslation } from "react-i18next";

const NewPanelSection = ({addedExercises, setAddedExercises, panelName, setPanelName, handleSelectExerciseOnEdit, handleDeleteExercise, handleDeleteNewPanel, t}:any) => {
    const controlOfAddedExercises = () => {
        if (addedExercises?.length === 0) {
            return false;
        }
        return true;
    }
    
    const [activeIndex, setActiveIndex] = useState(controlOfAddedExercises() ? 0 : -1);
    const { i18n } = useTranslation();

    const handleDeleteNewPanelOverride = (e:any) => {
        e.stopPropagation();
        handleDeleteNewPanel(e);
    }

    const moveCard = useCallback(
        (dragIndex: number, hoverIndex: number) => {
            setAddedExercises((prev:any[]) => {
                const copy = [...prev];
                const [moved] = copy.splice(dragIndex, 1);
                copy.splice(hoverIndex, 0, moved);
                return copy;
            });
        },
        [setAddedExercises]
    );

    const onTabChange = (e: any) => {
        const original = e.originalEvent as MouseEvent;
        if ((original.target as HTMLElement).closest("#panelName")) {
            return;
        }
        setActiveIndex(e.index);
    };

    const headerContent = () => {
        return (
            <div
                className="flex align-items-center justify-content-between m-2 pr-2"
                    style={{
                        height: "2rem"
                    }}
                >
                    <div className="flex gap-4 align-items-center">
                        <img src="/panelIcon.svg" style={{ backgroundColor: "#EBEDF2", borderRadius: "10px" }} />
                        <div className='w-25rem'>
                            <InputText id="panelName" className='w-full' style={{ borderRadius: "10px" }} value={panelName}
                                onChange={(e:any) => { setPanelName(e.target.value) }} placeholder={t("enterPanelName")} onKeyDown={(e:any) => e.stopPropagation()} />
                        </div>
                    </div>
                    <div className="flex gap-2">
                        <Button
                            icon={<img src="/redTrashIcon.svg" />}
                            onClick={(e) => handleDeleteNewPanelOverride(e)}
                            style={{
                                border: "none",
                                backgroundColor: "#FCEEF0",
                                borderRadius: "10px",
                                width: "2rem",
                                height: "2rem"
                            }} />
                    </div>
                </div>
            )
        }
    
        const DragItem = ({ exercise, index, moveCard }: any) => {
            const ref = useRef<HTMLDivElement>(null);

            const [{ handlerId }, drop] = useDrop({
                accept: "exercise",
                collect(monitor) {
                    return {
                        handlerId: monitor.getHandlerId(),
                    };
                },
                hover(item: any, monitor: any) {
                    if (!ref.current) {
                        return;
                    }
                    const dragIndex = item.index;
                    const hoverIndex = index;

                    if (dragIndex === hoverIndex) {
                        return;
                    }

                    const hoverBoundingRect = ref.current.getBoundingClientRect();
                    const hoverMiddleY = (hoverBoundingRect.bottom - hoverBoundingRect.top) / 2;
                    const clientOffset = monitor.getClientOffset();
                    
                    if (!clientOffset) {
                        return;
                    }
                    
                    const hoverClientY = clientOffset.y - hoverBoundingRect.top;

                    if (dragIndex < hoverIndex && hoverClientY < hoverMiddleY) {
                        return;
                    }

                    if (dragIndex > hoverIndex && hoverClientY > hoverMiddleY) {
                        return;
                    }

                    moveCard(dragIndex, hoverIndex);

                    item.index = hoverIndex;
                },
            });

            const [{ isDragging }, drag] = useDrag({
                type: "exercise",
                item: () => {
                    return { id: exercise.id, index };
                },
                collect: (monitor: any) => ({
                    isDragging: monitor.isDragging(),
                }),
            });

            const opacity = isDragging ? 0.4 : 1;
            drag(drop(ref));

            return (
                <div 
                    ref={ref} 
                    style={{ 
                        opacity,
                        cursor: "move",
                        borderRadius: "10px",
                        backgroundColor: isDragging ? "#f0f0f0" : "transparent"
                    }}
                    className="select-none flex align-items-center justify-content-between my-1 mx-2 p-2 pr-5"
                    data-handler-id={handlerId}
                >
                    <div className="flex gap-4 align-items-center">
                        <img src={exercise.image} width={50} height={50} style={{ backgroundColor: "#FFFFFF", borderRadius: "10px" }} />
                        <p className="font-bold text-md" style={{ color: "#2D3967" }}>{exercise.name}</p>
                    </div>
                    <div className="flex align-items-center gap-3">
                        <Button
                            icon={<img src="/editIconBlue.svg" />}
                            onClick={() => handleSelectExerciseOnEdit(exercise)}
                            style={{
                                border: "none",
                                backgroundColor: "#EBEDF2",
                                borderRadius: "10px",
                                width: "2rem",
                                height: "2rem"
                            }} 
                        />
                        <Button
                            icon={<img src="/redTrashIcon.svg" />}
                            onClick={() => handleDeleteExercise(exercise)}
                            style={{
                                border: "none",
                                backgroundColor: "#FCEEF0",
                                borderRadius: "10px",
                                width: "2rem",
                                height: "2rem"
                            }} 
                        />
                        <img src="/dragIcon.svg" style={{ cursor: "grab" }} />
                    </div>
                </div>
            );
        };

        const exerciseDivs = (panelExerciseList: any) => {
            return panelExerciseList.map((exercise: any, index: any) => (
                <div key={exercise.id} className="flex flex-column">
                    <DragItem
                        key={exercise.id}
                        index={index}
                        exercise={exercise}
                        moveCard={moveCard}
                    />
                </div>
            ));
        }
    
        const createDynamicTabs = () => {
            return (
                <AccordionTab disabled={!controlOfAddedExercises()} key={1} header={headerContent}>
                    {exerciseDivs(addedExercises)}
                </AccordionTab>
            );
        };
    
        return (
            <div className="w-full libraryAccordion overflow-auto">
                <Accordion activeIndex={activeIndex} onTabChange={onTabChange}>
                    {createDynamicTabs()}
                </Accordion>
            </div>
        )
}

export default NewPanelSection;